import { render } from "./OnboardingModal.vue?vue&type=template&id=f1669f02"
import script from "./OnboardingModal.vue?vue&type=script&lang=js"
export * from "./OnboardingModal.vue?vue&type=script&lang=js"

import "./OnboardingModal.vue?vue&type=style&index=0&id=f1669f02&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__